// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dQwc","image":"Header_image__4pbGX","name":"Header_name__1PiL7","info":"Header_info__LYDAS","infoRow":"Header_infoRow__3Madh"};